import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ElementRef,
} from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Panel } from "./s25.panels.component";

@TypeManagerDecorator("s25-ng-panel")
@Component({
    selector: "s25-ng-panel",
    template: `
        <s25-simple-collapse [headerText]="panel.header">
            <ng-container #dynamicContainer></ng-container>
            <!-- Render the component dynamically -->
            <ng-container #dynamicContainer></ng-container>
            @if (panel.content.html) {
                <ng-container>
                    <div [innerHTML]="panel.content.html"></div>
                </ng-container>
            }
        </s25-simple-collapse>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25PanelComponent implements OnInit {
    @Input({ required: true }) panel: Panel;

    @ViewChild("dynamicContainer", { read: ViewContainerRef, static: true })
    dynamicContainer: ViewContainerRef;

    ngOnInit() {
        this.renderPanel();
    }

    renderPanel() {
        this.dynamicContainer?.clear();
        if (this.panel.content.component) {
            const componentRef = this.dynamicContainer.createComponent(this.panel.content.component);

            // Pass inputs to the component
            Object.entries(this.panel.content.inputs || {}).forEach(([key, value]) => {
                componentRef.setInput(key, value);
            });

            // Bind outputs to the component
            Object.entries(this.panel.content.outputs || {}).forEach(([key, handler]) => {
                (componentRef.instance as any)[key]?.subscribe(handler);
            });
        }
    }
}
